// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".financial-period-filter[data-v-984e8ca4] {\n  width: 100%;\n}\r\n", ""]);
// Exports
module.exports = exports;
